import { createContext } from "react";
import useLotDetailsByProjectIdStageIdLotId from "../hooks/data/useLotDetailsByProjectIdStageIdLotId";

export interface ILotPropertiesContext extends ReturnType<typeof useLotDetailsByProjectIdStageIdLotId> {

};

const LotPropertiesContext = createContext<ILotPropertiesContext>({
    data: undefined,
    error: undefined,
    loading: true,
    validating: true,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined },
});

export default LotPropertiesContext